exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-application .logo-mini[data-v-41f123b4]{float:left;width:30px;text-align:center;margin-left:7px;margin-right:30px}.v-navigation-drawer[data-v-41f123b4]{box-shadow:none}", ""]);

// exports
